import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { Draggable } from "gsap/Draggable.js";

gsap.registerPlugin(ScrollTrigger, Draggable);

export const animations = function () {
    function initBirdview() {
        const birdviewContainer = document.querySelector("#birdView");
        const birdviewImg = birdviewContainer.querySelector("img");
    
        // console.log("????");
    
        const tl = gsap
            .timeline({ paused: true })
            .set(birdviewContainer, { y: 0 })
            .set(birdviewImg, { scale: 2 })
            //
            // .from(birdviewContainer, { duration: 1, "margin-left": 0, "margin-right": 0 })
            .to(birdviewContainer, { duration: 1, y: 0, "margin-left": "10vw", "margin-right": "10vw" })
            .to(birdviewImg, { duration: 1, scale: 1, autoAlpha: 1, ease: "power2.out" }, "-=1");
    
        return ScrollTrigger.create({
            trigger: birdviewImg,
            start: "top bottom",
            animation: tl,
            // markers: true,
            scrub: true,
        });
    
        // create a scrollTrigger
        // ScrollTrigger.create({
        //     trigger: birdviewContainer,
        //     start: "top center",
        //     end: "bottom center",
        //     animation: circleAnim,
        //     toggleActions: "play none none none",
        // });
    }
}



export const initPhotoReveal = function (className) {
    const photos = gsap.utils.toArray(className);
    photos.forEach((photo) => {
        const tl = gsap
            .timeline({ paused: true })
            .set(photo, { scale: 3 })
            .to(photo, { scale: 1, ease: "power2.out" });
        ScrollTrigger.create({
            trigger: photo,
            start: "top bottom",
            end: "center center",
            // end: "top top",
            animation: tl,
            // markers: true,
            scrub: true,
        });
    });
}